import KeyIcon from '@mui/icons-material/Key'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useCallback, useState } from 'react'

import { StructureDto } from '@/endpoints/models'
import { useAppContext, useAppDispatch, useAppStore } from '@/hooks'
import { loadNode } from '@/store/modules/node/general-actions'
import { hasStructureManageAccessPermission } from '@/utils/locking'

import { StructureAclModal } from './TreePanel/components/StructureAclModal'

export const PermissionsButton = ({ node }: { node: StructureDto }) => {
	const { t } = useAppContext()
	const dispatch = useAppDispatch()
	const nodes = useAppStore((s) => s.node.nodes) as Record<number, StructureDto>

	const [aclModalNode, setAclModalNode] = useState<StructureDto | null>(null)
	const [aclModalTargetId, setAclModalTargetId] = useState<number | null>(null)

	const handleOpen = useCallback(() => {
		setAclModalNode(node)
		setAclModalTargetId(null)
	}, [node])

	const handleClose = useCallback(() => {
		setAclModalNode(null)
		setAclModalTargetId(null)
	}, [])

	const handleAclMutated = useCallback(
		(structureId: number) => {
			void dispatch(loadNode(structureId))
		},
		[dispatch],
	)

	if (!hasStructureManageAccessPermission(node) || node.id == null) {
		return null
	}

	return (
		<>
			<MenuItem onClick={handleOpen}>
				<ListItemIcon>
					<KeyIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>{t('BUTTON_PERMISSIONS')}</ListItemText>
			</MenuItem>
			{aclModalNode?.id != null && (
				<StructureAclModal
					open={!!aclModalNode}
					onClose={handleClose}
					structureId={aclModalTargetId ?? aclModalNode.id}
					structureName={aclModalNode.name}
					parentStructureId={aclModalNode.parentStructureId}
					parentStructureName={
						aclModalNode.parentStructureId != null
							? nodes[aclModalNode.parentStructureId]?.name ??
								nodes[aclModalNode.parentStructureId]?.code
							: undefined
					}
					onOpenParentPermissions={
						aclModalNode.parentStructureId != null &&
						nodes[aclModalNode.parentStructureId]
							? () => {
									setAclModalNode(nodes[aclModalNode!.parentStructureId!])
									setAclModalTargetId(null)
								}
							: undefined
					}
					onOpenStructurePermissions={(targetStructureId) => {
						const target = nodes[targetStructureId]
						if (target) setAclModalNode(target)
						setAclModalTargetId(targetStructureId)
					}}
					onAclMutated={handleAclMutated}
				/>
			)}
		</>
	)
}
